<script>
  import {onMount} from 'svelte';
  import {External, M} from '../external';

  export let extraTags, onClick;
  let extraProperties = [];
  let crmProperties = [];
  let personalizationFields = [];

  onMount(function () {
	let crmPropertiesDisabled = extraTags && extraTags.hasCrmTags === false;
	if (!crmPropertiesDisabled) {
	  crmProperties = External.Website.crmProperties.slice();
	  crmProperties.unshift({
		label: M.LAST_NAME,
		name: 'last_name'
	  });
	  crmProperties.unshift({
		label: M.FIRST_NAME,
		name: 'first_name'
	  });
	}
	if (extraTags && extraTags.tags) {
	  extraProperties = extraTags.tags;
	}

	personalizationFields = [...External.Website.personalizationFields, {
	  name: M.CURRENT_YEAR,
	  tag: 'current_year'
	}];
  });

</script>

<div class='col20 f-left' style='padding: 0 35px 35px; box-sizing: border-box;'>
  {#if extraProperties && extraProperties.length}
	<div class='f-left col20 mb-25'>
	  <ul>
		{#each extraProperties as property}
		  <li class='rounded-effect' on:click={() => onClick(property)}>
			{M['EMAIL_PROP_' + property.toUpperCase()] || property}
		  </li>
		{/each}
	  </ul>
	</div>
  {/if}

  {#if crmProperties && crmProperties.length}
	<div class='f-left col20'>
	  <h3 class='popup-section-title col20 f-left mb-15'>{M.CRM_PROPERTIES}</h3>
	  <ul class='f-left col20'>
		{#each crmProperties as prop (prop)}
		  <li class='rounded-effect' on:click={() => onClick(prop.name)}>
			{prop.label}
			<span class='material-icons none'>info</span>
		  </li>
		{/each}
	  </ul>
	</div>
  {/if}

  <div class='f-left col20'>
	<h3 class='popup-section-title col20 f-left mb-15 mt-25'>{M.PERSONALIZATION}</h3>
	<ul class='f-left col20'>
	  {#each personalizationFields as field}
		<li class='rounded-effect' on:click={() => onClick(field.tag)}>
		  {field.name}
		  <span class='material-icons none'>info</span>
		</li>
	  {/each}
	</ul>
  </div>
</div>

<style>
  ul {
	list-style: none;
  }

  li {
	border-radius: 40px;
	background-color: #e6e9f0;
	cursor: pointer;
	padding: 8px 20px 8px 20px;
	margin: 4px;
	display: flex;
	width: auto;
	align-items: center;
	float: left;
  }

  li span {
	margin-left: 4px;
  }
</style>
